// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Signup page layout (scoped, builds on login.css .sq-* styles) */
.sq-signup .sq-left {
    flex: 0 0 55%;
    max-width: 55%;
    padding: 2rem 3rem;
    background: #fdfcf9;
}

.sq-signup .sq-right {
    width: 45%;
}

.sq-signup .logo-img {
    max-width: 150px;
}

.sq-signup .sq-form-section {
    width: 100%;
    max-width: 620px;
    justify-content: flex-start;
    padding-top: 0.5rem;
}

.sq-signup .sq-heading {
    text-align: center;
    font-size: 1.7rem;
    margin-bottom: 0.3rem;
}

.sq-signup .sq-subheading {
    text-align: center;
    margin-bottom: 1.2rem;
    font-size: 0.8rem;
}

.sq-signup .sq-input-wrap {
    margin-bottom: 0.9rem;
}

.sq-signup .sq-label {
    font-size: 0.75rem;
    color: #3b4a47;
}

/* ── Step cards ── */
.su-card {
    background: #f9f7f1;
    border: 1px solid #efeade;
    border-radius: 14px;
    padding: 1rem 1.1rem 0.9rem;
    margin-bottom: 0.9rem;
}

.su-card-head {
    display: flex;
    align-items: flex-start;
    gap: 0.6rem;
    margin-bottom: 0.8rem;
}

.su-step {
    flex: 0 0 24px;
    height: 24px;
    border-radius: 50%;
    background: #d9a21b;
    color: #fff;
    font-size: 0.78rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
}

.su-card-title {
    font-size: 0.95rem;
    font-weight: 700;
    color: var(--sq-dark);
    line-height: 1.2;
}

.su-card-desc {
    font-size: 0.72rem;
    color: var(--sq-text-muted);
    margin-top: 2px;
}

/* ── Provider tiles ── */
.su-providers {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0.6rem;
}

.su-provider {
    position: relative;
    background: #fff;
    border: 1px solid #ece7da;
    border-radius: 10px;
    padding: 0.7rem 0.7rem 0.6rem;
    text-align: left;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    transition: border-color 0.2s, box-shadow 0.2s;
    font-family: 'DM Sans', sans-serif;
}

.su-provider:hover,
.su-provider.active {
    border-color: var(--sq-gold);
    box-shadow: 0 0 0 3px rgba(227, 189, 62, 0.18);
}

.su-provider-logo {
    height: 38px;
    display: flex;
    align-items: center;
}

.su-provider-logo img {
    max-height: 30px;
    max-width: 100%;
    object-fit: contain;
}

.su-provider-name {
    font-weight: 800;
    font-size: 0.95rem;
    color: #1d4fb8;
    letter-spacing: 0.02em;
}

.su-provider-label {
    font-size: 0.7rem;
    color: #4a5a57;
    line-height: 1.25;
    padding-right: 14px;
}

.su-provider i {
    position: absolute;
    right: 10px;
    bottom: 12px;
    font-size: 9px;
    color: #6b7a77;
}

/* ── OR divider ── */
.sq-signup .sq-divider {
    margin: 0.8rem 0;
    font-size: 0.72rem;
}

/* ── Form grid ── */
.su-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 1rem;
}

.su-grid .sq-input-wrap {
    min-width: 0;
}

.sq-signup .sq-input,
.sq-signup .iti__tel-input {
    padding-top: 0.6rem;
    padding-bottom: 0.6rem;
    font-size: 0.8rem;
    background: #fbfaf6;
    border-radius: 8px;
    border-width: 1px;
}

.sq-signup .sq-input.no-icon {
    padding-left: 0.75rem;
}

.sq-signup .iti {
    width: 100%;
}

.sq-signup .iti__country-container {
    border-width: 1px;
    border-radius: 8px;
}

.sq-signup .iti__tel-input {
    padding-left: 5.5rem;
}

.sq-signup .select2-container {
    width: 100% !important;
}

.sq-signup .select2-container .select2-selection--single {
    height: 38px;
    border: 1px solid var(--sq-border);
    border-radius: 8px;
    background: #fbfaf6;
    display: flex;
    align-items: center;
}

.sq-signup .select2-container--default .select2-selection--single .select2-selection__rendered {
    line-height: 36px;
    font-size: 0.8rem;
    padding-left: 12px;
}

.sq-signup .select2-container--default .select2-selection--single .select2-selection__arrow {
    height: 36px;
}

.sq-signup .sq-btn-primary {
    background: #e6b93f;
    padding: 0.7rem;
    font-size: 0.85rem;
    margin-top: 0.3rem;
}

.sq-signup .sq-signup-link {
    margin-top: 0.9rem;
    font-size: 0.78rem;
}

.sq-signup .lineSpan {
    grid-column: 1 / -1;
}

.su-full {
    grid-column: 1 / -1;
}

@media (max-width: 1100px) {
    .su-providers {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 960px) {
    .sq-signup .sq-left {
        flex: 0 0 60%;
        max-width: 60%;
        padding: 1.5rem;
    }

    .sq-signup .sq-right {
        width: 40%;
    }
}

@media (max-width: 700px) {
    .sq-signup .sq-left {
        flex: none;
        max-width: 100%;
        padding: 1.5rem 1rem;
    }

    .sq-signup .sq-right {
        width: 100%;
    }

    .su-grid {
        grid-template-columns: 1fr;
    }
}

.su-manual-link {
    text-align: center;
    margin: 0.2rem 0 0.4rem;
}

.su-manual-link a {
    font-size: 0.8rem;
    font-weight: 600;
    color: var(--sq-gold-dark);
    text-decoration: none;
}

.su-manual-link a:hover {
    text-decoration: underline;
}

.su-modal .modal-body { padding: 1rem 1.25rem 1.25rem; }
.su-modal select.sq-input { padding-right: 0.75rem; }
.su-inuse {
    background: #fff4e5;
    border: 1px solid #f3d19c;
    color: #7a4b00;
    border-radius: 8px;
    padding: 0.6rem 0.8rem;
    font-size: 0.8rem;
    margin-bottom: 1rem;
}
.su-inuse a { font-weight: 700; color: var(--sq-gold-dark); }

.su-manual-link i { margin-right: 4px; font-size: 0.7rem; }

/* modal: errors flow under the field instead of being absolutely positioned */
.su-modal .sq-input-wrap { margin-bottom: 1rem; }
.su-modal .cus-err {
    position: static;
    display: block;
    margin-top: 4px;
    font-size: 0.75rem;
    line-height: 1.3;
}

/* white logos need a dark backdrop (same as the admin providers page) */
.su-provider-logo.dark img {
    background: #222c3c;
    padding: 6px 10px;
    border-radius: 8px;
    max-height: 34px;
}

.su-provider-logo.large img {
    max-height: 38px;
}
`, "",{"version":3,"sources":["webpack://./src/assest/css/signup.css"],"names":[],"mappings":"AAAA,kEAAkE;AAClE;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,qCAAqC;IACrC,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,8CAA8C;IAC9C,kCAAkC;AACtC;;AAEA;;IAEI,4BAA4B;IAC5B,8CAA8C;AAClD;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,aAAa;QACb,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;QACV,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,wBAAwB,6BAA6B,EAAE;AACvD,4BAA4B,sBAAsB,EAAE;AACpD;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;AACvB;AACA,cAAc,gBAAgB,EAAE,0BAA0B,EAAE;;AAE5D,oBAAoB,iBAAiB,EAAE,iBAAiB,EAAE;;AAE1D,8EAA8E;AAC9E,2BAA2B,mBAAmB,EAAE;AAChD;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,wEAAwE;AACxE;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":["/* Signup page layout (scoped, builds on login.css .sq-* styles) */\n.sq-signup .sq-left {\n    flex: 0 0 55%;\n    max-width: 55%;\n    padding: 2rem 3rem;\n    background: #fdfcf9;\n}\n\n.sq-signup .sq-right {\n    width: 45%;\n}\n\n.sq-signup .logo-img {\n    max-width: 150px;\n}\n\n.sq-signup .sq-form-section {\n    width: 100%;\n    max-width: 620px;\n    justify-content: flex-start;\n    padding-top: 0.5rem;\n}\n\n.sq-signup .sq-heading {\n    text-align: center;\n    font-size: 1.7rem;\n    margin-bottom: 0.3rem;\n}\n\n.sq-signup .sq-subheading {\n    text-align: center;\n    margin-bottom: 1.2rem;\n    font-size: 0.8rem;\n}\n\n.sq-signup .sq-input-wrap {\n    margin-bottom: 0.9rem;\n}\n\n.sq-signup .sq-label {\n    font-size: 0.75rem;\n    color: #3b4a47;\n}\n\n/* ── Step cards ── */\n.su-card {\n    background: #f9f7f1;\n    border: 1px solid #efeade;\n    border-radius: 14px;\n    padding: 1rem 1.1rem 0.9rem;\n    margin-bottom: 0.9rem;\n}\n\n.su-card-head {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.6rem;\n    margin-bottom: 0.8rem;\n}\n\n.su-step {\n    flex: 0 0 24px;\n    height: 24px;\n    border-radius: 50%;\n    background: #d9a21b;\n    color: #fff;\n    font-size: 0.78rem;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.su-card-title {\n    font-size: 0.95rem;\n    font-weight: 700;\n    color: var(--sq-dark);\n    line-height: 1.2;\n}\n\n.su-card-desc {\n    font-size: 0.72rem;\n    color: var(--sq-text-muted);\n    margin-top: 2px;\n}\n\n/* ── Provider tiles ── */\n.su-providers {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 0.6rem;\n}\n\n.su-provider {\n    position: relative;\n    background: #fff;\n    border: 1px solid #ece7da;\n    border-radius: 10px;\n    padding: 0.7rem 0.7rem 0.6rem;\n    text-align: left;\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    transition: border-color 0.2s, box-shadow 0.2s;\n    font-family: 'DM Sans', sans-serif;\n}\n\n.su-provider:hover,\n.su-provider.active {\n    border-color: var(--sq-gold);\n    box-shadow: 0 0 0 3px rgba(227, 189, 62, 0.18);\n}\n\n.su-provider-logo {\n    height: 38px;\n    display: flex;\n    align-items: center;\n}\n\n.su-provider-logo img {\n    max-height: 30px;\n    max-width: 100%;\n    object-fit: contain;\n}\n\n.su-provider-name {\n    font-weight: 800;\n    font-size: 0.95rem;\n    color: #1d4fb8;\n    letter-spacing: 0.02em;\n}\n\n.su-provider-label {\n    font-size: 0.7rem;\n    color: #4a5a57;\n    line-height: 1.25;\n    padding-right: 14px;\n}\n\n.su-provider i {\n    position: absolute;\n    right: 10px;\n    bottom: 12px;\n    font-size: 9px;\n    color: #6b7a77;\n}\n\n/* ── OR divider ── */\n.sq-signup .sq-divider {\n    margin: 0.8rem 0;\n    font-size: 0.72rem;\n}\n\n/* ── Form grid ── */\n.su-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    column-gap: 1rem;\n}\n\n.su-grid .sq-input-wrap {\n    min-width: 0;\n}\n\n.sq-signup .sq-input,\n.sq-signup .iti__tel-input {\n    padding-top: 0.6rem;\n    padding-bottom: 0.6rem;\n    font-size: 0.8rem;\n    background: #fbfaf6;\n    border-radius: 8px;\n    border-width: 1px;\n}\n\n.sq-signup .sq-input.no-icon {\n    padding-left: 0.75rem;\n}\n\n.sq-signup .iti {\n    width: 100%;\n}\n\n.sq-signup .iti__country-container {\n    border-width: 1px;\n    border-radius: 8px;\n}\n\n.sq-signup .iti__tel-input {\n    padding-left: 5.5rem;\n}\n\n.sq-signup .select2-container {\n    width: 100% !important;\n}\n\n.sq-signup .select2-container .select2-selection--single {\n    height: 38px;\n    border: 1px solid var(--sq-border);\n    border-radius: 8px;\n    background: #fbfaf6;\n    display: flex;\n    align-items: center;\n}\n\n.sq-signup .select2-container--default .select2-selection--single .select2-selection__rendered {\n    line-height: 36px;\n    font-size: 0.8rem;\n    padding-left: 12px;\n}\n\n.sq-signup .select2-container--default .select2-selection--single .select2-selection__arrow {\n    height: 36px;\n}\n\n.sq-signup .sq-btn-primary {\n    background: #e6b93f;\n    padding: 0.7rem;\n    font-size: 0.85rem;\n    margin-top: 0.3rem;\n}\n\n.sq-signup .sq-signup-link {\n    margin-top: 0.9rem;\n    font-size: 0.78rem;\n}\n\n.sq-signup .lineSpan {\n    grid-column: 1 / -1;\n}\n\n.su-full {\n    grid-column: 1 / -1;\n}\n\n@media (max-width: 1100px) {\n    .su-providers {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 960px) {\n    .sq-signup .sq-left {\n        flex: 0 0 60%;\n        max-width: 60%;\n        padding: 1.5rem;\n    }\n\n    .sq-signup .sq-right {\n        width: 40%;\n    }\n}\n\n@media (max-width: 700px) {\n    .sq-signup .sq-left {\n        flex: none;\n        max-width: 100%;\n        padding: 1.5rem 1rem;\n    }\n\n    .sq-signup .sq-right {\n        width: 100%;\n    }\n\n    .su-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n.su-manual-link {\n    text-align: center;\n    margin: 0.2rem 0 0.4rem;\n}\n\n.su-manual-link a {\n    font-size: 0.8rem;\n    font-weight: 600;\n    color: var(--sq-gold-dark);\n    text-decoration: none;\n}\n\n.su-manual-link a:hover {\n    text-decoration: underline;\n}\n\n.su-modal .modal-body { padding: 1rem 1.25rem 1.25rem; }\n.su-modal select.sq-input { padding-right: 0.75rem; }\n.su-inuse {\n    background: #fff4e5;\n    border: 1px solid #f3d19c;\n    color: #7a4b00;\n    border-radius: 8px;\n    padding: 0.6rem 0.8rem;\n    font-size: 0.8rem;\n    margin-bottom: 1rem;\n}\n.su-inuse a { font-weight: 700; color: var(--sq-gold-dark); }\n\n.su-manual-link i { margin-right: 4px; font-size: 0.7rem; }\n\n/* modal: errors flow under the field instead of being absolutely positioned */\n.su-modal .sq-input-wrap { margin-bottom: 1rem; }\n.su-modal .cus-err {\n    position: static;\n    display: block;\n    margin-top: 4px;\n    font-size: 0.75rem;\n    line-height: 1.3;\n}\n\n/* white logos need a dark backdrop (same as the admin providers page) */\n.su-provider-logo.dark img {\n    background: #222c3c;\n    padding: 6px 10px;\n    border-radius: 8px;\n    max-height: 34px;\n}\n\n.su-provider-logo.large img {\n    max-height: 38px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
